import {
  lazy,
  ReactElement,
  Suspense
} from 'react';
import {
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom';

import {
  RoutePath
} from '@/helper/helper-route';
import Error404 from '@/rc-container/error-404';
import RouteRoot from '@/route/_root';
import RouteHome from '@/route/home';

const PageCustomDictionary = lazy(() => import('@/route/custom-dictionary'));
const PageCalculate = lazy(() => import('@/route/calculate'));
const PageTenantManager = lazy(() => import('@/route/tenant-manager'));
const PageOfficialWebConfig = lazy(() => import('../route/official-web-config'));

const router = createBrowserRouter([
  {
    path: RoutePath.ROOT,
    element: <RouteRoot />,
    // errorElement: <ErrorPage />,
    // loader: rootLoader,
    // action: rootAction,
    children: [
      {
        index: true,
        element: <RouteHome />
      },
      {
        path: RoutePath.TABLE_STRUCTURE + '/*',
        element: <Suspense><PageCustomDictionary pathPrefix={RoutePath.TABLE_STRUCTURE} /></Suspense>
      },
      {
        path: RoutePath.CALCULATE + '/*',
        element: <Suspense><PageCalculate pathPrefix={RoutePath.CALCULATE} /></Suspense>
      },
      {
        path: RoutePath.TENANT_MANAGER + '/*',
        element: <Suspense><PageTenantManager pathPrefix={RoutePath.TENANT_MANAGER} /></Suspense>
      },
      {
        path: RoutePath.OFFICIAL_WEB_CONFIG + '/*',
        element: <Suspense><PageOfficialWebConfig pathPrefix={RoutePath.OFFICIAL_WEB_CONFIG} /></Suspense>
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
]);

export default function App(): ReactElement {
  return <RouterProvider router={router} />;
}
